// TRUE deploy target — used by `npm run build:lichen-dev` to produce the
// bundle that gets synced to S3 (home-lichen-dev) and served at
// https://app.lichen.com via CloudFront (E24EHC8WIPP56O).
module.exports = {
  defaultSubdomain: 'drumwave',
  apiUrl: 'https://app-api.lichen.com',
  studioUrl: 'https://app-studio.lichen.com',
  // public embed links (the /embed page of this app; there is no embed.lichen.com here)
  embedUrl: 'https://app.lichen.com',
  bucket: 'home-lichen-dev',
  logout: 'lichen.com/logout',
  sentry: {
    dsn: 'https://e89017876a1d4798a67eb0d971289c49@sentry.io/1861374',
    env: 'DEVELOPMENT'
  }
}
